export default "__VITE_ASSET__BaMcpTEU__"